import React from 'react'
import { Button, Modal } from 'antd'

import StatusCell from '../StatusCell'
import InternalKeyCodeCell from '../InternalKeyCodeCell'
import { INTERNAL_KEY_STATUS_OPTIONS } from '../utils'

const createInternalKeyFields = canReadCode => ([
  {
    label: 'Property',
    renderValue: ({ key }) => key?.property?.internalListingName || '--'
  },
  {
    label: 'Unit',
    renderValue: ({ key }) => {
      if (!key?.UnitID) {
        return '--'
      }

      const unit = key.property.listingUnits.find(unit => {
        return unit.id === Number(key.UnitID)
      })

      return unit.name
    }
  },
  {
    label: 'Internal Key Name',
    renderValue: ({ key }) => key?.InternalKeyName || '--'
  },
  {
    label: 'Internal Key Type',
    renderValue: ({ key }) => key?.InternalKeyType || '--'
  },
  canReadCode && {
    label: 'Code',
    renderValue: ({ key, activeKeyId, setActiveKeyId }) =>
      <div className={`${activeKeyId.length
        ? 'w-[220px]'
        : 'w-[120px] mt-[5px]'} text-center`}>
        <InternalKeyCodeCell
          setActiveKeyIds={setActiveKeyId}
          id={key?._id}
        />
      </div>,
  },
  {
    label: 'Status',
    renderValue: ({ key, canUpdate, refetch, onClose }) => key?.status
      ? (
        <StatusCell
          disabled={!canUpdate}
          onSuccess={onClose}
          refetch={refetch}
          name={key?.InternalKeyName}
          typeName="internal key"
          requestKey="updateInternalKeyStatus"
          statusOptions={INTERNAL_KEY_STATUS_OPTIONS}
          _id={key._id}
          status={key.status}
        />
      )
      : '--'
  }
].filter(Boolean))

function InternalKeyDetailsModal (props) {
  const {
    canDelete,
    canUpdate,
    canReadCode,
    handleDeleteModalOpen,
    internalKey,
    onClose,
    open,
    triggerCollectionRefetch
  } = props

  const [activeKeyId, setActiveKeyId] = React.useState([])

  const handleClose = () => {
    setActiveKeyId([])
    onClose()
  }

  return (
    <Modal
      title='Internal key details'
      open={open}
      footer={null}
      destroyOnClose
      onCancel={handleClose}
    >
      <div className="grid sm:grid-cols-2 gap-2 pt-2">
        {createInternalKeyFields(canReadCode).map(({ label, renderValue }) => (
          <div key={label}>
            <div className="font-semibold">
              {label}
            </div>

            <div>
              {renderValue({
                key: internalKey, activeKeyId, setActiveKeyId,
                canUpdate, refetch: triggerCollectionRefetch, onClose
              })}
            </div>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-end gap-2 pt-10">
        {canDelete && (
          <Button
            onClick={handleDeleteModalOpen}
            className="mr-auto"
            type="primary"
            danger
          >
            Delete internal key
          </Button>
        )}

        <Button
          className="hover:!text-black hover:!border-labelGrey"
          onClick={handleClose}
        >
          Close
        </Button>
      </div>
    </Modal>
  )
}

export default InternalKeyDetailsModal
